module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "m-billingFrequency",
    attrs: {
      "data-billing-period": _vm.billingFrequency
    }
  }, [_vm._v("\n  " + _vm._s(_vm.billingStartDateMessage) + "\n  " + _vm._s(_vm.billingFrequencyMessage) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54e225d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/BillingFrequency.vue
// module id = 532
// module chunks = 2